export default "__VITE_ASSET__Bakrfsv3__"